import { render, staticRenderFns } from "./PartnerConnectionReceivedDetail.vue?vue&type=template&id=7c234ec4&scoped=true"
import script from "./PartnerConnectionReceivedDetail.vue?vue&type=script&lang=js"
export * from "./PartnerConnectionReceivedDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerConnectionReceivedDetail.vue?vue&type=style&index=0&id=7c234ec4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c234ec4",
  null
  
)

export default component.exports